export interface DimDatatableColumnStyle {
  color?: string;
}
